import { render } from "./PaymentCompleted.vue?vue&type=template&id=5c9b3408"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"

import "./PaymentCompleted.vue?vue&type=style&index=0&id=5c9b3408&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__